import React from 'react';

import Riva from '../../../../assets/logos/podeMorar/Riva.svg';
import Direcional from '../../../../assets/logos/podeMorar/Direcional.svg';

import { NavbarSindicoContainer } from './styles';

import { NavbarSindicoCenter, NavbarContainerItems, MenuItem } from '../styles';
import { ReactComponent as ExitIcon } from '../../../../assets/novosicones/Sindico/exit_to_app.svg';

const NavbarSindicoDesktop = ({
  goToHome,
  goToSolicitations,
  goToDocuments,
  handleLogoutSindico,
  activeRoute,
}) => {
  console.log(activeRoute);
  return (
    <NavbarSindicoContainer>
      <NavbarSindicoCenter>
        <NavbarContainerItems>
          <img src={Direcional} width={164} height={22} />
          <img src={Riva} width={87} height={26} />
        </NavbarContainerItems>
        <NavbarContainerItems>
          <MenuItem
            onClick={goToHome}
            isActive={activeRoute === '/sindico/inicio/'}
          >
            INÍCIO
          </MenuItem>
          <MenuItem
            onClick={goToSolicitations}
            isActive={activeRoute === '/sindico/solicitacoes-abertas/'}
          >
            SOLICITAÇÕES
          </MenuItem>
          <MenuItem
            onClick={goToDocuments}
            isActive={activeRoute === '/sindico/documentos/'}
          >
            DOCUMENTOS
          </MenuItem>
          <MenuItem onClick={handleLogoutSindico}>
            SAIR <ExitIcon />
          </MenuItem>
        </NavbarContainerItems>
      </NavbarSindicoCenter>
    </NavbarSindicoContainer>
  );
};

export default NavbarSindicoDesktop;
